import React from 'react';
import { Link } from 'react-router-dom';
import useSquareConnectInfo from './use-square-connect-info';

// One-line proactive warning for Square feature surfaces (menu editor,
// inventory, import wizard). Renders nothing for healthy connections and
// for companies without Square.
const SquareReconnectStrip = () => {
  const { needsReconnect } = useSquareConnectInfo();
  if (!needsReconnect) return null;
  return (
    <div className="mb-3 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-800 dark:border-amber-500/40 dark:bg-amber-500/10 dark:text-amber-200">
      Square connection needs to be renewed —{' '}
      <Link
        to="/dashboard/settings/integrations"
        className="font-semibold underline"
      >
        go to Settings → Integrations
      </Link>
      .
    </div>
  );
};

export default SquareReconnectStrip;
